const React = require('react');
const noop = require('mn-utils/noop');
const withState = require('../../../../../utils/withState');
const {openPopupInfo} = require("../../../../../emitters/popup");

module.exports = withState((setState, self, onMount) => {

  const initialData = self.props.data || {};
  const initialErrors = self.props.errors || {};
  const hasInitialErrors = !!Object.keys(initialErrors).length;

  self.state = {
    ...self.state,
    data: initialData,
    errors: initialErrors,
    click: hasInitialErrors,
    hasChanges: hasInitialErrors,
    loading: false,
  };

  onMount(() => {

  })

  const checkErrors = (data) => {
    const schema = self.props.schema;
    const errors = {};

    if (!schema) return errors;

    try {
      schema.default.validateSync(data, {abortEarly: false});
    } catch (e) {
      if (e.inner && e.inner.length) {
        e.inner.forEach(({path, message}) => {
          errors[path] = message;
        });
      } else {
        console.log(e);
      }
    }

    return errors;
  }

  const saveChanges = (changes) => {
    const result = !self.state.hasChanges ? {...changes, hasChanges: true} : changes;
    setState(result);
  }

  const change = (name, value) => {
    const data = {...(self.state.data || {})};

    data[name] = value;

    const errors = checkErrors(data);

    saveChanges({data, errors});
  }

  const manualDataChange = (values) => {
    const data = {...(self.state.data || {}), ...values};
    const errors = checkErrors(data);
    saveChanges({data, errors});
  }

  const onReqError = (e) => {
    const errors = {};

    console.log('HERE!');
    console.log(e.field);

    if (e.field) {
      errors[e.field] = e.message;
    } else {
      errors['request'] = e.message;
    }

    setState({errors});
  }

  const showResultInfoModal = () => {
    const {data} = self.state || {};
    const {resultModalData, resultModalHandler} = self.props || {};

    const resultModalProps = resultModalHandler
      ? resultModalHandler(data)
      : resultModalData;

    if (!resultModalProps) return;

    openPopupInfo(resultModalProps);
  };

  const disableFormAfterSubmit = () => {
    const {disableFormAfterSubmit} = self.props || {};

    if (disableFormAfterSubmit) setState({hasChanges: false});
  }

  const submit = (e) => {
    e.preventDefault();

    const {data} = self.state || {};
    const {onSubmit, onResult = noop} = self.props || {};

    const errors = checkErrors(data);

    const click = true;

    console.log('----submitErrors', errors);

    if (Object.keys(errors).length) {
      setState({click, errors});
      return;
    }

    if (!onSubmit) return onResult(data);

    setState({click, loading: true});

    return onSubmit(data, self)
        .then(onResult)
        .then(showResultInfoModal)
        .then(disableFormAfterSubmit)
        .catch(onReqError)
        .finally(() => {
          setState({loading: false});
        });
  }

  self.onChange = (...rest) => change(...rest);
  self.onManualChange = (...rest) => manualDataChange(...rest);
  self.enableLoadingState = () => setState({loading: true});
  self.disableLoadingState = () => setState({loading: false});
  self.onUpload = () => {};

  return (state, props) => {
    return (
      <form className={props.className} onSubmit={submit} autoComplete={props.autoComplete}>
        {props.children && props.children(self)}
      </form>
    )
  }
});
